/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import * as actionType from './actionTypes';

const initialState = {
  dialog: {
    results: null,
    selection: {
      type: null,
      text: null,
      additionalInfo: null,
      additionalOperation: null
    }
  },
  open: false,
  show: false
};

// ----------------------------------------
const dialogNodeSelected = (state, action) => ({
  ...state,
  dialog: {
    results: state.dialog.results,
    selection: action.payload
  }
});

const showSearch = (state, action) => ({ ...state, show: action.show });

const toggleSearch = state => ({ ...state, open: !state.open });

const closeSearch = state => ({ ...state, open: false });
// ----------------------------------------

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.DIALOG_SEARCH_RESULT_SELECTED:
      return dialogNodeSelected(state, action);
    case actionType.SHOW_SEARCH:
      return showSearch(state, action);
    case actionType.TOGGLE_SEARCH:
      return toggleSearch(state, action);
    case actionType.CLOSE_SEARCH:
      return closeSearch(state, action);
    default:
      return state;
  }
};

export default reducer;
